<template>
  <div class="dashboard">
    <DashboardSelectPeriod />

    <zi-row justify="start" align="top">
      <div class="zi-col-8">
        <div class="zi-card">
          <h2>{{ issues.length }}</h2>
          <h5>Issues</h5>
        </div>
      </div>

      <div class="zi-col-8">
        <div class="zi-card">
          <h2>{{ labeled }}</h2>
          <h5>Labeled</h5>
        </div>
      </div>

      <div class="zi-col-8">
        <div class="zi-card">
          <h2>{{ notLabeled.length }}</h2>
          <h5>Not labeled</h5>
        </div>
      </div>
    </zi-row>

    <zi-row justify="start" align="top">
      <zi-col span="12">
        <h3>Label-pie</h3>
        <LabelChart />
      </zi-col>

      <zi-col span="12">
        <h3>Labels</h3>
        <table class="zi-table">
          <thead>
            <tr>
              <th>Label</th>
              <th>
                <zi-tooltip :content="'Total all open: '+ (grantTotal - grandTotalClosed)" placement="left">
                  Open
                </zi-tooltip>
              </th>
              <th>
                <zi-tooltip :content="'Total closed: '+ grandTotalClosed" placement="left">
                  Closed
                </zi-tooltip>
              </th>
              <th id="labelTotal">
                <zi-tooltip :content="'SUM all totals: '+ grantTotal" placement="left">
                  Total
                </zi-tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr :key="label.id" v-for="label in projectLabels">
              <td v-text="label.name"></td>
              <td v-text="label.open_issues_count"></td>
              <td v-text="label.closed_issues_count"></td>
              <td v-text="label.total_issues"></td>
            </tr>
          </tbody>
        </table>
      </zi-col>
    </zi-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import values from 'lodash-es/values'
import keys from 'lodash-es/keys'
import orderBy from 'lodash-es/orderBy'
import { Datetime } from 'vue-datetime'
import LabelChart from '../components/LabelChart'
import DashboardSelectPeriod from '../components/DashboardSelectPeriod'

export default {
  name: 'Dashboard',
  components: { LabelChart, Datetime, DashboardSelectPeriod },
  beforeRouteEnter(a, b, next) {
    next(vm => {
      if (!vm.$store.getters.hasToken) {
        vm.$router.push({ name: 'hello' })
      } else if (vm.$store.getters.hasToken && !vm.$store.getters.project) {
        vm.$router.push({ name: 'select-project' })
      }
    })
  },
  computed: {
    dateFrom() {
      return this.$store.getters.dateFrom
    },
    dateTo() {
      return this.$store.getters.dateTo
    },
    issues() {
      return this.$store.getters.issuesAll.filter(issue => {
        let iss = dayjs(issue.created_at)

        if (!this.dateFrom || !this.dateTo) {
          return true
        }

        return (
          (iss.isAfter(this.dateFrom) || iss.isSame(this.dateFrom)) &&
          (iss.isBefore(this.dateTo) || iss.isSame(this.dateTo))
        )
      })
    },
    notLabeled() {
      return this.issues.filter(issue => issue.labels.length === 0)
    },
    labeled() {
      return this.issues.length - this.notLabeled.length
    },
    labels() {
      return this.$store.getters.getLabels
    },
    projectLabels() {
      return orderBy(this.labels, ['total_issues'], ['desc'])
    },
    grantTotal() {
      return this.labels.length === 0
        ? 0
        : this.labels.reduce((res, label) => {
            if (typeof res === 'object') {
              res = res.total_issues
            }

            return (res += label.total_issues)
          })
    },
    grandTotalClosed() {
      return this.labels.length === 0
        ? 0
        : this.labels.reduce((res, label) => {
            if (typeof res === 'object') {
              res = res.closed_issues_count
            }

            return (res += label.closed_issues_count)
          })
    }
  },
}
</script>


<style scoped>
.dashboard {
  padding-top: 94px;
}
[class*='zi-col-'] {
  padding: 20px;
}
.zi-row {
  padding-bottom: 40px;
}
.table-total {
  border-top: 1px solid black;
}
.no-border {
  border-bottom: 0;
}
</style>